import * as ecgActions from '../actions/ecg.actions';
import * as ecgListActions from '../actions/ecg-list.actions';
import { loadEcgList } from './load-ecg-list.thunk';
import { first } from 'lodash';
import { loadNextAnnotation } from './load-next-annotation.thunk';
import { AppThunk } from '../../../store/rootReducer';

type LoadingStatusValue =
  | { type: 'success'; ecgId: string }
  | { type: 'empty' }
  | { type: 'error' };

export const loadNextEcg =
  (): AppThunk<Promise<LoadingStatusValue>> => async (dispatch) => {
    const annotationEcgId = await dispatch(loadNextAnnotation());
    dispatch(ecgActions.clean({ meta: { history: false } }));

    if (annotationEcgId != null) {
      // the user has been assigned an annotation task, we handle it first
      return { type: 'success', ecgId: annotationEcgId };
    }

    // there is no annotation task, we default to ECGs in the user's dataset
    dispatch(ecgListActions.incrementIndex({ meta: { history: false } }));

    const ecgList = await dispatch(loadEcgList());

    if (ecgList == null) {
      return { type: 'error' };
    }

    const firstEcg = first(ecgList);

    if (firstEcg == null) {
      return { type: 'empty' };
    }

    return { type: 'success', ecgId: firstEcg.id };
  };
